import React, {Fragment} from 'react';
import './GameCard.css';
import {useNavigate, useNavigation} from "react-router-dom";
import axios from "axios";

const GameCard = ({date, weekday, time, active, cort, gameId}) => {

    const navigate = useNavigate();

    const openGame = () => {
        navigate('/game', {state:
                            {
                                date: date,
                                weekday: weekday,
                                time: time,
                                active: active,
                                cort: cort,
                                gameId: gameId
                            }
        })
    }

    function getMonthNumber(monthName) {
        const monthNames = {
            "Января": "01",
            "Февраля": "02",
            "Марта": "03",
            "Апреля": "04",
            "Мая": "05",
            "Июня": "06",
            "Июля": "07",
            "Августа": "08",
            "Сентября": "09",
            "Октября": "10",
            "Ноября": "11",
            "Декабря": "12"
        };

        return monthNames[monthName] || "Неверное название месяца";
    }

    const deleteGame = () => {
        if(window.confirm('Точно хотите отменить игру?')) {
            let time_hour = parseInt(time.split(':')[0]) - 3;
            // let date_format = new Date(date.split()[2], getMonthNumber(date.split()[1]), date.split()[0]);
            let getCorts;
            axios.get(`/api/get_courts/`, {headers: { 'Content-Type': 'application/json' }, withCredentials: true})
                .then(res => {
                    getCorts = res.data.detail;
                    let cort_id;
                    if (cort==='1'){
                        cort_id = getCorts[0].id_cort;
                    } else if (cort==='2') {
                        cort_id = getCorts[1].id_cort;
                    }
                    axios.post(`/api/delete_order/${cort_id}/`, {id_cort: cort_id, time_start: `${date.split(' ')[2]}-${getMonthNumber(date.split(' ')[1])}-${date.split(' ')[0]}T${time_hour}:00:00.000Z`, players_count: 2}, {headers: {
                            'Content-Type': 'application/json',
                            'Access-Control-Allow-Origin': '*',
                            'X-CSRFToken': getCookie('csrftoken'),
                            'Access-Control-Allow-Headers': 'X-CSRFToken' }, withCredentials: true})
                        .then(res => {
                            console.log(res.status);
                            if (res.status===200) {
                                alert('Игра успешно отменена');
                                window.location.reload();
                            }
                        })
                        .catch(e => {
                            console.log(e);
                            if (e.status === 409) {
                                alert('Нельзя отменить бронирование менее чем за 4 часа');
                            }
                        })
                })
                .catch(e => {
                    console.log(e);
                })

        }
    }

    return (
        <div className={'card-and-delete-container'}>

            <div className={`profile-game-card ${active ? 'profile-game-card-active' : ''}`} onClick={() => openGame()}>
                <div className={'game-card-icon'}></div>
                <div className={'game-card-text'}>
                    <p className={'game-card-text-date'}>{date}</p>
                    <p className={'game-card-text-time'}>{weekday}, {time}</p>
                    <p className={'game-card-text-date'}>Корт №{cort}</p>
                </div>
            </div>

            <div className={`delete-game-button ${active ? 'delete-game-button-active' : ''}`} onClick={deleteGame}>
                <svg version="1.1" id="game_bin" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                     viewBox="-13 -13 170.63 170.63">
                    <g>
                        <path fill="#FFFFFF" d="M72.31,0C32.38,0,0,32.38,0,72.31s32.38,72.31,72.31,72.31s72.31-32.38,72.31-72.31S112.25,0,72.31,0z
                             M110.79,55.46c-0.59,4.86-1.2,9.72-1.79,14.58c-0.55,4.54-1.1,9.07-1.65,13.61c-0.63,5.16-1.27,10.32-1.9,15.48
                            c-0.56,4.56-1.1,9.11-1.65,13.67c-0.3,2.51-0.55,5.02-0.95,7.51c-0.6,3.76-3.75,6.79-7.67,7.49c-0.73,0.13-1.48,0.21-2.22,0.21
                            c-13.76,0.01-27.52,0.03-41.28,0c-3.95-0.01-7.05-1.66-9.03-5.17c-0.74-1.31-0.9-2.78-1.08-4.25c-0.47-3.95-0.97-7.89-1.45-11.84
                            c-0.48-3.91-0.95-7.82-1.42-11.73c-0.48-3.93-0.96-7.86-1.44-11.79c-0.48-3.89-0.95-7.78-1.42-11.67
                            c-0.48-3.93-0.96-7.86-1.44-11.78c-0.19-1.59-0.41-3.19-0.57-4.78c-0.22-2.25,1.68-4.46,4.12-4.8c0.45-0.06,0.92-0.08,1.37-0.08
                            c11.08,0,22.16,0,33.25,0c11.18,0,22.36,0,33.53,0c1.89,0,3.39,0.67,4.3,2.41C110.86,53.43,110.91,54.44,110.79,55.46z
                             M114.09,38.13c-0.15,2.15-1.72,3.51-3.88,3.59c-0.2,0.01-0.39,0.01-0.59,0.01c-24.87,0-49.74,0-74.6-0.01
                            c-0.69,0-1.42-0.09-2.06-0.31c-1.36-0.47-2.27-1.52-2.36-2.93c-0.13-2.18-0.25-4.4,0.07-6.54c0.61-4.13,4.11-6.93,8.29-6.94
                            c6.7-0.01,13.4,0,20.1,0c0.21,0,0.42,0,0.7,0c0.05-1.6,0.42-3.06,1.26-4.36c1.64-2.54,3.98-3.92,7.01-3.98
                            c2.81-0.06,5.62-0.02,8.43-0.01c4.53,0.01,8.19,3.51,8.41,8.01c0,0.1,0.01,0.19,0.02,0.35c0.23,0,0.43,0,0.64,0
                            c6.72,0,13.43-0.02,20.15,0.01c3.05,0.01,5.44,1.32,7.14,3.85c0.76,1.13,1.24,2.39,1.28,3.75
                            C114.15,34.44,114.21,36.29,114.09,38.13z"/>
                        <polygon fill="#FFFFFF" points="85.85,67.55 72.31,81.09 58.78,67.55 50.29,76.04 63.83,89.58 50.29,103.11 58.78,111.6
                            72.31,98.06 85.85,111.6 94.34,103.11 80.8,89.58 94.34,76.04"/>
                    </g>
                </svg>
            </div>
        </div>
    );
};

function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

export default GameCard;